import { render, staticRenderFns } from "./Jawn.vue?vue&type=template&id=66e8bc9b&scoped=true&"
import script from "./Jawn.vue?vue&type=script&lang=js&"
export * from "./Jawn.vue?vue&type=script&lang=js&"
import style0 from "./Jawn.vue?vue&type=style&index=0&id=66e8bc9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e8bc9b",
  null
  
)

export default component.exports